import QueryString from 'qs';
import { ManagedByAgencyType, CreatorQueryType } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
import { BooleanValue, CreatorListFilterEnum, SortByEnum } from './constants';
import { ContentTypeFilterConfig, CreatorScoreFilterConfig, FollowerAgeFilterConfig, FollowerGenderFilterConfig, FOLLOWERS_MAX_FILTER_NUMBER, FOLLOWERS_MIN_FILTER_NUMBER } from './components/creator-search/constants';
import { PageType } from '../track';
import { PairSourceEnum } from '../utils';
export function shouldUseRecommended(searchParams) {
  return !searchParams.query && searchParams.sortBy === SortByEnum.DEFAULT;
}
export var parseDefaultFiltersFromUrl = function parseDefaultFiltersFromUrl(shouldProcessProductCategory) {
  var _location$search;
  if ((_location$search = location.search) !== null && _location$search !== void 0 && _location$search.startsWith('?')) {
    var _QueryString$parse = QueryString.parse(location.search.slice(1)),
      product_category = _QueryString$parse.product_category,
      follower_min_count = _QueryString$parse.follower_min_count,
      creator_score = _QueryString$parse.creator_score;
    var params = {};
    if (follower_min_count) {
      var followerCount = {
        min: Number(follower_min_count),
        max: FOLLOWERS_MAX_FILTER_NUMBER
      };
      params.followerCount = followerCount;
    }
    if (creator_score) {
      var creatorScore = CreatorScoreFilterConfig.config.find(function (item) {
        return item.value === Number(creator_score);
      });
      if (creatorScore) {
        params.creatorScore = creatorScore === null || creatorScore === void 0 ? void 0 : creatorScore.value;
      }
    }
    if (shouldProcessProductCategory && product_category) {
      params.productCategory = [JSON.stringify([product_category].filter(Boolean))];
    }
    return params;
  }
  return undefined;
};
export var getTrackSearchParam = function getTrackSearchParam(searchParams, permission) {
  var _followerCount$min, _followerCount$max;
  var query = searchParams.query,
    otherFilter = searchParams.otherFilter,
    followerAgeGroup = searchParams.followerAgeGroup,
    followerGender = searchParams.followerGender,
    followerCount = searchParams.followerCount,
    creatorScore = searchParams.creatorScore,
    contentType = searchParams.contentType,
    managedByAgency = searchParams.managedByAgency,
    sortBy = searchParams.sortBy,
    sortMode = searchParams.sortMode,
    productCategory = searchParams.productCategory;
  var hasCreatorScorePermission = permission.hasCreatorScorePermission,
    hasBindMCNPermission = permission.hasBindMCNPermission;
  var trackParams = {
    userName: query !== null && query !== void 0 ? query : '',
    productCategory: productCategory !== null && productCategory !== void 0 ? productCategory : [],
    creatorScore: Boolean(hasCreatorScorePermission) && creatorScore ? generateCommon(creatorScore, CreatorScoreFilterConfig) : '',
    contentType: Boolean(hasCreatorScorePermission) && contentType ? generateCommon(contentType, ContentTypeFilterConfig) : '',
    followerGender: followerGender ? generateCommon(followerGender, FollowerGenderFilterConfig) : '',
    followerAgeGroup: followerAgeGroup ? generateCommon(followerAgeGroup, FollowerAgeFilterConfig) : '',
    followerCount: {
      min: (_followerCount$min = followerCount === null || followerCount === void 0 ? void 0 : followerCount.min) !== null && _followerCount$min !== void 0 ? _followerCount$min : FOLLOWERS_MIN_FILTER_NUMBER,
      max: (_followerCount$max = followerCount === null || followerCount === void 0 ? void 0 : followerCount.max) !== null && _followerCount$max !== void 0 ? _followerCount$max : FOLLOWERS_MAX_FILTER_NUMBER
    },
    sort: {
      sortBy: sortBy,
      sortMode: sortMode
    },
    managedByAgency: hasBindMCNPermission ? generateBooleanValue(Boolean(managedByAgency)) : BooleanValue.FALSE,
    isActiveCreator: generateBooleanValue(otherFilter === null || otherFilter === void 0 ? void 0 : otherFilter.isActiveCreator),
    isHighSampleDispatchRate: generateBooleanValue(otherFilter === null || otherFilter === void 0 ? void 0 : otherFilter.isHighSampleDispatchRate),
    isQuicklyResponse: generateBooleanValue(otherFilter === null || otherFilter === void 0 ? void 0 : otherFilter.isQuicklyResponse)
  };
  return trackParams;
};
export var isFilterStatus = function isFilterStatus(searchParams) {
  var filterEnumValues = Object.values(CreatorListFilterEnum);
  var filterStatus = false;
  for (var _i = 0, _filterEnumValues = filterEnumValues; _i < _filterEnumValues.length; _i++) {
    var key = _filterEnumValues[_i];
    if (key === CreatorListFilterEnum.OtherFilter) {
      var _searchParams$key;
      filterStatus = hasLabelFilter((_searchParams$key = searchParams[key]) !== null && _searchParams$key !== void 0 ? _searchParams$key : {});
    } else if (key === CreatorListFilterEnum.ManagedByAgency) {
      filterStatus = searchParams[key] === ManagedByAgencyType.YES;
    } else {
      var value = searchParams[key];
      filterStatus = Array.isArray(value) ? Boolean(value.length) : Boolean(value);
    }
    if (filterStatus) {
      return true;
    }
  }
  return false;
};
var hasLabelFilter = function hasLabelFilter(otherFilter) {
  for (var key in otherFilter) {
    if (otherFilter[key]) {
      return true;
    }
  }
  return false;
};
var generateBooleanValue = function generateBooleanValue(value) {
  return value ? BooleanValue.TRUE : BooleanValue.FALSE;
}; // transform searchParam to trackParam，eg：creatorScore = 1 => creatorScore = '5-4'
var generateCommon = function generateCommon(selected, filterConfig) {
  var config = filterConfig.config.find(function (item) {
    if (Array.isArray(item.value)) {
      return item.value[0] === selected.min && item.value[1] === selected.max;
    } else {
      return item.value === selected;
    }
  });
  return config === null || config === void 0 ? void 0 : config.name.default;
};
export var QueryDetailedTypeEnum = /*#__PURE__*/function (QueryDetailedTypeEnum) {
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["QUERY_DEFAULT"] = 0] = "QUERY_DEFAULT";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["MANUAL"] = 1] = "MANUAL";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["PRODUCT_HINT"] = 2] = "PRODUCT_HINT";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["CONTENT_HINT_HASHTAG"] = 3] = "CONTENT_HINT_HASHTAG";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["CONTENT_HINT_MENTION"] = 4] = "CONTENT_HINT_MENTION";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["CONTENT_HINT_KEYWORD"] = 5] = "CONTENT_HINT_KEYWORD";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["CREATOR_SUG"] = 6] = "CREATOR_SUG";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["PRODUCT_SUG"] = 7] = "PRODUCT_SUG";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["CONTENT_SUG_HASHTAG"] = 8] = "CONTENT_SUG_HASHTAG";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["CONTENT_SUG_MENTION"] = 9] = "CONTENT_SUG_MENTION";
  QueryDetailedTypeEnum[QueryDetailedTypeEnum["CONTENT_SUG_KEYWORD"] = 10] = "CONTENT_SUG_KEYWORD";
  return QueryDetailedTypeEnum;
}({});
export var getQueryDetailedType = function getQueryDetailedType(query, type) {
  switch (type) {
    case CreatorQueryType.CREATOR_SUG:
      return QueryDetailedTypeEnum.CREATOR_SUG;
    case CreatorQueryType.PRODUCT_SUG:
      return QueryDetailedTypeEnum.PRODUCT_SUG;
    case CreatorQueryType.PRODUCT_HINT:
      return QueryDetailedTypeEnum.PRODUCT_HINT;
    case CreatorQueryType.CONTENT_SUG:
      {
        switch (query === null || query === void 0 ? void 0 : query[0]) {
          case '#':
            return QueryDetailedTypeEnum.CONTENT_SUG_HASHTAG;
          case '@':
            return QueryDetailedTypeEnum.CONTENT_SUG_MENTION;
          default:
            return QueryDetailedTypeEnum.CONTENT_SUG_KEYWORD;
        }
      }
    case CreatorQueryType.CONTENT_HINT:
      {
        switch (query === null || query === void 0 ? void 0 : query[0]) {
          case '#':
            return QueryDetailedTypeEnum.CONTENT_HINT_HASHTAG;
          case '@':
            return QueryDetailedTypeEnum.CONTENT_HINT_MENTION;
          default:
            return QueryDetailedTypeEnum.CONTENT_HINT_KEYWORD;
        }
      }
    case CreatorQueryType.MANUAL:
      return QueryDetailedTypeEnum.MANUAL;
    default:
    case CreatorQueryType.QUERY_DEFAULT:
      return QueryDetailedTypeEnum.QUERY_DEFAULT;
  }
};
export function getPageType(param) {
  var search = param.search,
    filter = param.filter;
  if (search && filter) {
    return PageType.SearchFilter;
  } else if (search) {
    return PageType.Search;
  } else if (filter) {
    return PageType.Filter;
  } else {
    return PageType.Default;
  }
}
export var getPairSource = function getPairSource(searchParams) {
  var query = searchParams.query,
    sortBy = searchParams.sortBy,
    productCategory = searchParams.productCategory,
    followerAgeGroup = searchParams.followerAgeGroup,
    followerCount = searchParams.followerCount,
    followerGender = searchParams.followerGender,
    otherFilter = searchParams.otherFilter;
  if (sortBy !== SortByEnum.DEFAULT || followerCount || productCategory !== null && productCategory !== void 0 && productCategory.length || followerAgeGroup || followerGender || otherFilter && Object.values(otherFilter).every(function (value) {
    return !value;
  })) {
    return PairSourceEnum.AUTHOR_FILTER;
  }
  return query ? PairSourceEnum.AUTHOR_SEARCH : PairSourceEnum.AUTHOR_RECOMMEND;
}; /** get total video list */
export var getVideoList = function getVideoList(_ref) {
  var profiles = _ref.profiles,
    rule = _ref.rule;
  return profiles.map(function (profile) {
    var top_video_data = profile.top_video_data;
    if (top_video_data !== null && top_video_data !== void 0 && top_video_data.is_authorized && top_video_data.value && top_video_data.value.length > 0) {
      var _rule;
      var filteredVideoList = (_rule = rule === null || rule === void 0 ? void 0 : rule(top_video_data.value)) !== null && _rule !== void 0 ? _rule : top_video_data.value;
      return filteredVideoList.filter(function (item) {
        return item.video;
      }).map(function (item) {
        var _item$name, _item$release_date, _item$like_cnt, _item$play_cnt, _item$comment_cnt;
        return {
          video: {
            itemId: item.item_id || '',
            video: item.video,
            title: (_item$name = item.name) !== null && _item$name !== void 0 ? _item$name : '',
            date: Number((_item$release_date = item.release_date) !== null && _item$release_date !== void 0 ? _item$release_date : 0),
            likeCount: Number((_item$like_cnt = item.like_cnt) !== null && _item$like_cnt !== void 0 ? _item$like_cnt : 0),
            playCount: Number((_item$play_cnt = item.play_cnt) !== null && _item$play_cnt !== void 0 ? _item$play_cnt : 0),
            commentCount: Number((_item$comment_cnt = item.comment_cnt) !== null && _item$comment_cnt !== void 0 ? _item$comment_cnt : 0),
            products: (item === null || item === void 0 ? void 0 : item.video_products) || []
          },
          profile: profile
        };
      });
    } else {
      return [];
    }
  }).flat();
};
export var transformIdlFormateToComponent = function transformIdlFormateToComponent(props) {
  return {
    is_authorized: true,
    value: props || []
  };
};